module.exports = __webpack_public_path__ + "static/media/saucelabs_test_logo_signin.7c18535f.svg";